/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetImportPreviewStatusQueryResponse,
  GetImportPreviewStatusPathParams,
  GetImportPreviewStatus404,
} from '../types/GetImportPreviewStatus'

function getGetImportPreviewStatusUrl({
  import_number,
}: {
  import_number: GetImportPreviewStatusPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/status/` as const,
  }
  return res
}

/**
 * @summary Get the processing status of an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/status/}
 */
export async function getImportPreviewStatus(
  {
    import_number,
  }: { import_number: GetImportPreviewStatusPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetImportPreviewStatusQueryResponse,
    ResponseErrorConfig<GetImportPreviewStatus404>,
    unknown
  >({
    method: 'GET',
    url: getGetImportPreviewStatusUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
